import { render, staticRenderFns } from "./EmployeeAnnouncementDetails.vue?vue&type=template&id=d2a86e6e&scoped=true&"
import script from "./EmployeeAnnouncementDetails.vue?vue&type=script&lang=js&"
export * from "./EmployeeAnnouncementDetails.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAnnouncementDetails.vue?vue&type=style&index=0&id=d2a86e6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a86e6e",
  null
  
)

export default component.exports